import orangeGear from '@images/icons/orange-gear.svg';
import weeklySprintsOrange from '@static/images/icons/weekly-sprints-orange.svg';
import communicationOrange from '@images/icons/communication-orange.svg';

export const stages = [
	{
		icon: orangeGear,
		title: 'Development flow',
	},
	{
		icon: weeklySprintsOrange,
		title: 'Weekly sprints',
	},
	{
		icon: communicationOrange,
		title: 'Communication',
	},
];
